export const VALIDATE_STRONG_PASSWORD = false;

export const STRONG_PASSWORD_OPTIONS = {
  minLength: 8,
  minLowercase: 1,
  minUppercase: 1,
  minNumbers: 1,
  minSymbols: 1,
  returnScore: false
}

export const COMPLETE_MODULES = {
  spFunction: true,
  spComponents: true,
  pGroups: true,
  benefits: true,
  models: true,
  wizard: true,
  scenarios: true,
  log: true
}